// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutocompleteResults__autoCompleteItems___Owy0Z {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #e4e4e4;
  border-radius: 0 0 3px 3px;
  background-color: #fff;
}

.AutocompleteResults__autoCompleteItems___Owy0Z ul {
    list-style: none;
    padding: 0;
  }

.AutocompleteResults__autoCompleteItems___Owy0Z ul:last-child li:last-child {
        border: 0;
      }

.AutocompleteResults__autoCompleteItems___Owy0Z li {
    cursor: pointer;
    padding: 8px;
    padding-top: 10px;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: 1px solid rgba(195, 195, 195, 0.45);
    display: flex;
    align-items: center;
  }

.AutocompleteResults__autoCompleteItems___Owy0Z li:hover {
      background-color: rgba(55, 110, 161, 0.1);
    }

.AutocompleteResults__autoCompleteItems___Owy0Z .AutocompleteResults__active___wHQV5 {
    background-color: rgba(55, 110, 161, 0.1);
  }

.AutocompleteResults__autoCompleteItems___Owy0Z .AutocompleteResults__user_icon___LzXXp {
    fill: #8a8a8a;
    color: #8a8a8a;
  }

.AutocompleteResults__autoCompleteItems___Owy0Z .AutocompleteResults__autoCompleteItems_sectionTitle___PzcMq {
    display: block;
  }

.AutocompleteResults__autoCompleteItems___Owy0Z .AutocompleteResults__autoCompleteItems_label___YTAkF span {
      display: block;
    }

.AutocompleteResults__autoCompleteItems___Owy0Z .AutocompleteResults__autoCompleteItems_icon___xFsuX {
    margin-right: 18px;
  }

.AutocompleteResults__user_icon___LzXXp {
  fill: #8a8a8a;
  color: #8a8a8a;
}

.AutocompleteResults__small___SHiBD {
  font-size: 12px;
  font-weight: bold;
}

.AutocompleteResults__accountMeta___UWqPv {
  display: flex;
  align-items: center;
  gap: 8px;
}

.AutocompleteResults__accountPrimary___umyHN {
  display: flex;
  align-items: center;
  gap: 8px;
}

.AutocompleteResults__statusBadge___Dh9wP {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
}

.AutocompleteResults__statusBadge___Dh9wP::before {
  content: '';
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.AutocompleteResults__statusActive___TLb2K {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.AutocompleteResults__statusActive___TLb2K::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.AutocompleteResults__statusClosed___iSluR {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.AutocompleteResults__statusClosed___iSluR::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.AutocompleteResults__statusClosing___q161e,
.AutocompleteResults__statusSuspended___uhAT7 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.AutocompleteResults__statusClosing___q161e::before,
.AutocompleteResults__statusSuspended___uhAT7::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.AutocompleteResults__statusDefault___sX3vv {
  color: #5f5f5f;
}

.AutocompleteResults__statusDefault___sX3vv::before {
  background: #8a8a8a;
}

.AutocompleteResults__matchedText___F1k3l {
  font-weight: 200;
  display: inline !important;
}

.AutocompleteResults__noResults___Dtgww {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #666;
}

.AutocompleteResults__noResultsIcon___TCFom {
  margin-bottom: 8px;
  opacity: 0.5;
}

.AutocompleteResults__noResultsText___qTIrL {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Contacts/components/Search/Autocomplete/AutocompleteResults.css"],"names":[],"mappings":"AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AAmDxB;;AAjDE;IACE,gBAAgB;IAChB,UAAU;EAOZ;;AAJI;QACE,SAAS;MACX;;AAIJ;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,yCAAyC;IAC3C;;AAGF;IACE,yCAAyC;EAC3C;;AAEA;IACE,aAAa;IACb,cAAc;EAChB;;AAEA;IACE,cAAc;EAChB;;AAGE;MACE,cAAc;IAChB;;AAGF;IACE,kBAAkB;EACpB;;AAGF;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mDAAc;AAChB;;AAEA;EACE,wDAAmB;AACrB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,wDAAiB;AACnB;;AAEA;;EAEE,mDAAmB;AACrB;;AAEA;;EAEE,wDAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@value colors: \"styles/colors.css\";\n@value gtRed, gtGreen, gtYellowDark from colors;\n\n.autoCompleteItems {\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border: 1px solid #e4e4e4;\n  border-radius: 0 0 3px 3px;\n  background-color: #fff;\n\n  ul {\n    list-style: none;\n    padding: 0;\n\n    &:last-child {\n      li:last-child {\n        border: 0;\n      }\n    }\n  }\n\n  li {\n    cursor: pointer;\n    padding: 8px;\n    padding-top: 10px;\n    height: 50px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: 1px solid rgba(195, 195, 195, 0.45);\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      background-color: rgba(55, 110, 161, 0.1);\n    }\n  }\n\n  .active {\n    background-color: rgba(55, 110, 161, 0.1);\n  }\n\n  .user_icon {\n    fill: #8a8a8a;\n    color: #8a8a8a;\n  }\n\n  .autoCompleteItems_sectionTitle {\n    display: block;\n  }\n\n  .autoCompleteItems_label {\n    span {\n      display: block;\n    }\n  }\n\n  .autoCompleteItems_icon {\n    margin-right: 18px;\n  }\n}\n\n.user_icon {\n  fill: #8a8a8a;\n  color: #8a8a8a;\n}\n\n.small {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.accountMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.accountPrimary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.statusBadge {\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n}\n\n.statusBadge::before {\n  content: '';\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  margin-right: 4px;\n}\n\n.statusActive {\n  color: gtGreen;\n}\n\n.statusActive::before {\n  background: gtGreen;\n}\n\n.statusClosed {\n  color: gtRed;\n}\n\n.statusClosed::before {\n  background: gtRed;\n}\n\n.statusClosing,\n.statusSuspended {\n  color: gtYellowDark;\n}\n\n.statusClosing::before,\n.statusSuspended::before {\n  background: gtYellowDark;\n}\n\n.statusDefault {\n  color: #5f5f5f;\n}\n\n.statusDefault::before {\n  background: #8a8a8a;\n}\n\n.matchedText {\n  font-weight: 200;\n  display: inline !important;\n}\n\n.noResults {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  color: #666;\n}\n\n.noResultsIcon {\n  margin-bottom: 8px;\n  opacity: 0.5;\n}\n\n.noResultsText {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"autoCompleteItems": `AutocompleteResults__autoCompleteItems___Owy0Z`,
	"active": `AutocompleteResults__active___wHQV5`,
	"user_icon": `AutocompleteResults__user_icon___LzXXp`,
	"autoCompleteItems_sectionTitle": `AutocompleteResults__autoCompleteItems_sectionTitle___PzcMq`,
	"autoCompleteItems_label": `AutocompleteResults__autoCompleteItems_label___YTAkF`,
	"autoCompleteItems_icon": `AutocompleteResults__autoCompleteItems_icon___xFsuX`,
	"small": `AutocompleteResults__small___SHiBD`,
	"accountMeta": `AutocompleteResults__accountMeta___UWqPv`,
	"accountPrimary": `AutocompleteResults__accountPrimary___umyHN`,
	"statusBadge": `AutocompleteResults__statusBadge___Dh9wP`,
	"statusActive": `AutocompleteResults__statusActive___TLb2K`,
	"statusClosed": `AutocompleteResults__statusClosed___iSluR`,
	"statusClosing": `AutocompleteResults__statusClosing___q161e`,
	"statusSuspended": `AutocompleteResults__statusSuspended___uhAT7`,
	"statusDefault": `AutocompleteResults__statusDefault___sX3vv`,
	"matchedText": `AutocompleteResults__matchedText___F1k3l`,
	"noResults": `AutocompleteResults__noResults___Dtgww`,
	"noResultsIcon": `AutocompleteResults__noResultsIcon___TCFom`,
	"noResultsText": `AutocompleteResults__noResultsText___qTIrL`
};
export default ___CSS_LOADER_EXPORT___;
